"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformLinkingConnectionStatus = void 0;
var PlatformLinkingConnectionStatus;
(function (PlatformLinkingConnectionStatus) {
    PlatformLinkingConnectionStatus["NotConnected"] = "not_connected";
    PlatformLinkingConnectionStatus["Connected"] = "connected";
    PlatformLinkingConnectionStatus["Disconnected"] = "disconnected";
    PlatformLinkingConnectionStatus["PuuidMissing"] = "puuid_missing";
    PlatformLinkingConnectionStatus["HasNotFinishedActivities"] = "has_not_finished_activities";
})(PlatformLinkingConnectionStatus = exports.PlatformLinkingConnectionStatus || (exports.PlatformLinkingConnectionStatus = {}));
//# sourceMappingURL=platform-linking-connection-status.js.map